import React from 'react'
import { Link } from 'react-router-dom'
import { Col, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import styled from 'styled-components'
import i18n from 'i18n'
import IconTo from 'components/IconTo'
import { RTL } from 'locales/currentLang'
import langUrl from '../../../../CampaignSystem/utils/langUrl'

const TagsContainer = styled(Link)`
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 6px 26px 0 rgba(0, 0, 0, 0.08);
  border: none;
  cursor: pointer;
  &:hover {
    text-decoration: none;
  }
`
export default function Tags() {
  return (
    <TagsContainer to={`/${langUrl}/influencer/tags`} className="card">
      <Row className="card-body p-3">
        <Col md={10} xs={10}>
          <h2 className="title">{i18n.t('influencer.dashboard.audience')}</h2>
          <p className="description">
            {i18n.t('influencer.dashboard.audience-hint')}
          </p>
        </Col>
        <Col className="arrow">
          <IconTo direction={RTL().toString()} />
        </Col>
      </Row>
    </TagsContainer>
  )
}
